import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import swal from 'sweetalert2';
import { DataService } from '../../../../services/data.service';
import { IssueService } from '../../../../services/issue.service';
import { getQueryParamFromAncestorRoute } from '../../../../utilities/route.utilities';

@Component({
    selector: 'issue-latest-bill-estimated-grid-item',
    templateUrl: './issues-latest-bill-estimated-grid-item.component.html',
})
export class IssuesLatestBillEstimatedGridItemComponent implements OnInit, OnDestroy {

    clientId: number;
    subscriptions: any[] = [];
    data: any[] = [];
    page: number = 1;
    totalPages: number = 1;
    pageSize: number = 10;
    siteId: number;

    constructor(private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router,
        private dataService: DataService
    ) {
        this.subscriptions.push(router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.ngOnInit();
            }
        }));
    }

    ngOnInit() {
        this.clientId = getQueryParamFromAncestorRoute(this.route, 'clientId');
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');

        this.subscriptions.push(this.route
            .queryParams
            .subscribe(queryParams => {
                if (+queryParams['latestBillEstimatedPage']) {
                    this.page = +queryParams['latestBillEstimatedPage'];
                } else { this.page = 1 }
            }));


        this.getData();       
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    isValidDate(item: any): boolean {
        let date = new Date(item.latestedNonEstimatedBill);
        let yearString = date.getFullYear().toString();
        if (yearString === "1" || item.latestedNonEstimatedBill == null) {
            return false;
        } else {
            return true;
        }
    }

    getPage(page: number) {
        this.page = page;
        this.getData();
    }

    getData() {
        this.issueService.getBillingLatestBillEstimatedDetail(this.clientId, this.page, this.pageSize, this.siteId).then((result) => {
            this.data = [];
            if (result && result.items && result.items.length > 0) {
                this.dataService.issuesBillingLatestBillEstimatedGridItemComponentResolved.next(true);
                this.data = result.items;
                this.totalPages = result.totalPages;
                this.pageSize = result.pageSize;
                this.page = result.currentPage;
            } else { this.dataService.issuesBillingLatestBillEstimatedGridItemComponentResolved.next(false); }
        }, error => this.dataService.issuesBillingLatestBillEstimatedGridItemComponentResolved.next(false)
        )
    }

    onInfoClick() {
        swal({
            title: 'Estimated bills',
            html: '<p style="text-align: left;">This widget highlights where the latest bill for a consumer contains an estimate.</p>\
            <p style="text-align: left;">Using estimated readings for billing purposes can have the potential to cause problems. This could include incorrect revenue, increasing debt and negative customer experience. It can also indicate a wider issue with hardware.</p>\
            <p style="text-align: left;">Billing regulations and Heat Trust code of conduct, where applicable, state that a consumer must receive at least one actual bill every 12 months.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
